import React, { useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import Select from "react-select";
import { Cookies } from '../../index.js';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { alert_error, alert_success } from '../../AppContext';
function Editinfotask({ item, showedit, setshowedit, loadinfo, loadtask, options }) {
    const [options2, setoptions2] = useState([
        {
            id: '1', stt: '', name: 'Link giới thiệu',
            money: '', status: 'show', content: '', value: 'link_ref'
        },
        {
            id: '2', stt: '', name: 'Nhập mã giới thiệu',
            money: '', status: 'show', content: '', value: 'promo_code'
        },
        {
            id: '3', stt: '', name: 'Cho thuê tool',
            money: '', status: 'show', content: '', value: 'app_auto_jop'
        }
    ]);
    const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
    const [nutxuly, setnutxuly] = useState(0);
    const [name, setname] = useState('');
    const [price, setprice] = useState('');
    const [time, settime] = useState('');
    const [week, setweek] = useState('');
    const [month, setmonth] = useState('');
    const [guide, setguide] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [category, setcategory] = useState('');
    const [received, setreceived] = useState('');
    const [api_url, setapi_url] = useState('');
    const [api_key, setapi_key] = useState('');
    const [img, setimg] = useState('');
    const [content, setcontent] = useState('');
    const [id_mission, setid_mission] = useState('');
    const [selectedOption, setSelectedOption] = useState(''); // Chọn giá trị ban đầu
    const [base64Image, setBase64Image] = useState(null);
    const navigate = useNavigate();
    const handleOptionChange = (selectedOption) => {
        setIsOpen(false);
        if (selectedOption) {
            setSelectedOption(selectedOption);
            const selectedValue = selectedOption.value;
            console.log(selectedValue);
            setcategory(selectedValue);
            const selectedOptionOk = options2.find((option) => option.servicecode === selectedValue);
            // Add other actions here based on the user's selection
        }
    };
    const handleImageChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const reader = new FileReader();

            reader.onloadend = () => {
                setBase64Image(reader.result);
            };

            reader.readAsDataURL(file);
        }
    };


    const handleFocus = () => {
        setIsOpen(true);
        console.log(123);
    };
    const handleBlur = () => {
        setIsOpen(false);
    };
    const handleMenuOpen = () => {
        setIsOpen(true);
    };

    const exitedit = () => {
        setshowedit(false);
    };
    const checkedit = () => {
        if (item) {
            if (item.price) {
                setname(item.name);
                // // Chuyển đổi item.price và item.received thành số, sau đó tính toán giá trị price
                // let price = +item.price / (+item.received) * 100;
                // // Làm tròn giá trị price đến hàng chục
                // price = Math.round(price / 10) * 10;
                // // In ra giá trị price
                // console.log(price);
                setprice(item.price);
                settime(item.time);
                setguide(item.guide);
                setreceived(item.received);
                setapi_url(item.api_url);
                setapi_key(item.api_key);
                setid_mission(item.id_mission);
                setcontent(item.content);
                setimg(item.img);
                if (item.category) {
                    setcategory(item.category);
                    console.log(item.category);
                    // Tìm giá trị mặc định dựa trên giá trị của thuộc tính 'category'
                    const optionok = options2.map((option) => ({
                        value: option.value,
                        label: option.name,
                    }));
                    const defaultOption = optionok.find(option => option.value === item.category);
                    console.log(defaultOption);
                    if (defaultOption) {

                        setSelectedOption(defaultOption);
                    }
                }
                else {
                    setIsOpen(true);
                }
            }
        }
        else {
            setIsOpen(true);
        }
    };
    function handleSubmit(event) {
        setnutxuly(1);
        const apikey = Cookies.get('apikey');
        event.preventDefault();
        setnutorder('Please wait a moment 😊');
        if (!name || !price || !time || !received || !category || !content) {
            alert_error('Please điền đầy đủ thông tin')
            setnutxuly(0);
            setnutorder('điền đủ thông tin');
            return
        }
        if (!isNaN(received)) {
            if (received < 0 || received > 100) {
                alert_error('%Pay Users nằm trong khoảng từ 0 đến 100')
                setnutxuly(0);
                setnutorder('✔️ Click to Confirm');
                return
            }
        }
        else {
            alert_error('%Pay Users phải là 1 số')
            setnutorder('✔️ Click to Confirm');
            setnutxuly(0);
            return
        }
        const url = 'https://hust.media/jop/mission/infotask_edit.php';
        let data = JSON.stringify({
            "name": name,
            "price": price,
            "time": time,
            "guide": guide,
            "received": received,
            "category": category,
            "api_url": api_url,
            "api_key": api_key,
            "id_mission": id_mission,
            "content": content,
            "week": week,
            "month": month,
            "img": base64Image,
        });
        axios.post(url, data)
            .then(
                response => (testFunction(response))
            )
            .catch(error => errorapi(error))

    };
    function infotask_delete() {
        setnutxuly(1);
        const apikey = Cookies.get('apikey');
        setnutorder('Please wait a moment 😊');
        if (!apikey || !id_mission) {
            alert_error('Please điền đầy đủ thông tin')
            setnutxuly(0);
            setnutorder('điền đủ thông tin');
            return
        }
        const url = 'https://hust.media/jop/mission/infotask_delete.php';
        axios.get(url, {
            params: {
                apikey: apikey,
                id_mission: id_mission
            }
        })
            .then(
                response => (navigate('/reactapp/addusers'))
            )
            .catch(error => errorapi(error))

    };
    function errorapi(error) {
        alert_error(error);
        setnutxuly(0);
    };
    function testFunction(response) {
        setnutxuly(0);
        const info = response.data;
        const status = info.status;
        const message = info.message;
        setnutorder('đặt tiếp luôn nào')
        if (status == 0) {
            alert_error(info.message);
        }
        else if (status == 1) {
            alert_success(info.message);
            if (id_mission) {
                loadinfo();
            } else if (!id_mission) {
                loadtask();
            }
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };
    useEffect(() => {
        if (options) {
            if (options[1]) {
                if (options[0].money) {
                    setweek(options[0].money);
                }
                if (options[1].money) {
                    setmonth(options[1].money);
                }
            }
        }
    }, [options]);
    useEffect(() => {
        // embedtele();
        checkedit();
    }, []);
    return (
        <>
            {
                showedit &&
                (
                    <>
                        <form className="mx-2 mt-1 add-form">
                            <div className="form-control">
                                <div className='flex items-center justify-between flex-1'>
                                    <label className="mb-2 text-lg">Chỉnh sửa nhiệm vụ
                                        {item && (<>  {item.id_mission}</>)}
                                    </label>
                                    <label onClick={exitedit} className="mb-2 px-2 ">Đóng</label>
                                </div>
                                <Select
                                    classNamePrefix="Chọn 1 lựa chọn"
                                    onFocus={handleFocus}
                                    value={selectedOption} // Giá trị ban đầu
                                    options={options2.map((option) => ({
                                        value: option.value,
                                        label: `${option.name}`,
                                    }))}
                                    className="mb-2"
                                    menuIsOpen={isOpen}
                                    isDisabled={isDisabled}
                                    onBlur={handleBlur}
                                    onMenuOpen={handleMenuOpen}
                                    onChange={handleOptionChange}
                                    isLoading={false}
                                    isClearable={true}
                                    isRtl={false}
                                    isSearchable={false}
                                />
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping">
                                        Tên App
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Điền tên app vd: zalo pay"
                                        aria-label="inputlienket"
                                        value={name}
                                        name="inputlienket"
                                        aria-describedby="addon-wrapping"
                                        onChange={e => setname(e.target.value)}
                                    />
                                </div>
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping">
                                        Lời chào mời
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Ví dụ: Đăng ký app nhận tiền"
                                        aria-label="inputlienket"
                                        value={content}
                                        name="inputlienket"
                                        aria-describedby="addon-wrapping"
                                        onChange={e => setcontent(e.target.value)}
                                    />
                                </div>
                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping">
                                        App pay
                                    </span>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Số tiền app trả cho giới thiệu 1 người dùng"
                                        aria-label="inputlienket"
                                        value={price}
                                        name="inputlienket"
                                        aria-describedby="addon-wrapping"
                                        onChange={e => setprice(e.target.value)}
                                    />
                                </div>
                                {
                                    category == 'app_auto_jop'
                                        ?
                                        (<>
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="addon-wrapping">
                                                    Tuần
                                                </span>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Số Coins thuê theo tuần"
                                                    aria-label="inputlienket"
                                                    value={week}
                                                    name="inputlienket"
                                                    aria-describedby="addon-wrapping"
                                                    onChange={e => setweek(e.target.value)}
                                                />
                                            </div>
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="addon-wrapping">
                                                    Tháng
                                                </span>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Số Coins thuê theo tháng"
                                                    aria-label="inputlienket"
                                                    value={month}
                                                    name="inputlienket"
                                                    aria-describedby="addon-wrapping"
                                                    onChange={e => setmonth(e.target.value)}
                                                />
                                            </div>
                                        </>) :
                                        (<>
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="addon-wrapping">
                                                    Time duyệt
                                                </span>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Số ngày duyệt tiền người dùng"
                                                    aria-label="inputlienket"
                                                    value={time}
                                                    name="inputlienket"
                                                    aria-describedby="addon-wrapping"
                                                    onChange={e => settime(e.target.value)}
                                                />
                                            </div>
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="addon-wrapping">
                                                    Link tele
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Link bài viết hướng dẫn ở telegram"
                                                    aria-label="inputlienket"
                                                    value={guide}
                                                    name="inputlienket"
                                                    aria-describedby="addon-wrapping"
                                                    onChange={e => setguide(e.target.value)}
                                                />
                                            </div>
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="addon-wrapping">
                                                    % Pay Users
                                                </span>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="% số tiền người làm jop nhận"
                                                    aria-label="inputlienket"
                                                    value={received}
                                                    name="inputlienket"
                                                    aria-describedby="addon-wrapping"
                                                    onChange={e => setreceived(e.target.value)}
                                                />
                                            </div>
                                        </>)}
                                {
                                    category == 'link_ref'
                                        ?
                                        (<>
                                            <div className="input-group flex-nowrap">
                                                <span className="input-group-text" id="addon-wrapping">
                                                    Link giới thiệu
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Link giới thiệu app"
                                                    aria-label="inputlienket"
                                                    value={api_url}
                                                    name="inputlienket"
                                                    aria-describedby="addon-wrapping"
                                                    onChange={e => setapi_url(e.target.value)}
                                                />
                                            </div></>)
                                        : category === 'promo_code' ?
                                            (<>
                                                <div className="input-group flex-nowrap">
                                                    <span className="input-group-text" id="addon-wrapping">
                                                        Mã giới thiệu
                                                    </span>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Mã giới thiệu ứng dụng"
                                                        aria-label="inputlienket"
                                                        value={api_key}
                                                        name="inputlienket"
                                                        aria-describedby="addon-wrapping"
                                                        onChange={e => setapi_key(e.target.value)}
                                                    />
                                                </div>
                                            </>) : null
                                }
                                <div>
                                    Ảnh app <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        className="rounded"
                                    />
                                    {base64Image && (
                                        <div>
                                            <img src={base64Image} alt="Selected" className="w-44 rounded" />
                                        </div>
                                    )}
                                </div>
                                <button disabled={nutxuly == 1} onClick={handleSubmit}
                                    className='mt-2 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-2 w-full dark:bg-slate-800 dark:text-white'>
                                    <div className='flex items-center justify-between flex-1'>
                                        {nutxuly == 1 &&
                                            <div className="spinner-border" role="status">

                                            </div>}


                                        <span className='text-lg font-medium text-white'>
                                            {nutorder} </span>
                                            <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                                    </div>
                                </button>
                                {id_mission &&
                                    (<>
                                        <div onClick={infotask_delete} className='text-sm'>  Xóa nhiệm vụ
                                        </div>
                                    </>)
                                }
                            </div>
                        </form>
                    </>
                )
            }
        </>
    );
}

export default Editinfotask;
